
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import ListComponent from '../../global/components/List/index.vue'
import { dollarDisplay, toTitleCase } from '../../global/functions/util'

@Component({
  components: { ListComponent }
})
export default class DisbursementsList extends Vue {
  get filterOptions() {
    return [
        { text: 'Event Source', key: 'eventSource', type: 'string' },
        { text: 'Event Source ID', key: 'sourceId', type: 'number' },
        { text: 'Related Source', key: 'relatedSource', type: 'string' },
        { text: 'Related Source ID', key: 'relatedSourceId', type: 'number' },
        { text: 'Bucket', key: 'bucketName', type: 'string' },
        { text: 'Amount', key: 'amount', type: 'number' },
        { text: 'Date', key: 'date', type: 'date' }
    ]
  }

  get availableColumns() {
    return [
        { text: 'Bucket', value: 'bucketName' },
        { text: 'Event Source', value: 'eventSource', display: { type: 'item', render: this.displayEventSource }, sortable: false },
        { text: 'Related Source', value: 'relatedSource', display: { type: 'item', render: this.displayRelatedSource }, sortable: false, fsExclude: true },
        { text: 'Amount', value: 'amount', display: dollarDisplay, fsExclude: true },
        { text: 'Date', value: 'date', type: 'date' }
    ]
  }

  get defaultColumns() {
    return ['bucketName', 'eventSource', 'relatedSource', 'amount', 'date']
  }
  
  get actions() {
    return []
  }

  get list() {
    return this.$refs.list as ListComponent<any>
  }
  displayEventSource(item: any) {
    return `${toTitleCase(item.eventSource)} (#${item.sourceId})`
  }
  
  displayRelatedSource(item: any) {
    return `${toTitleCase(item.relatedSource)} (#${item.relatedSourceId})`
  }
}
